import styled from 'styled-components';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { themeColor } from '@hud/web-components/theme/colors';

const Container = styled.div`
  margin-left: auto;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 16px;
`;

const ConfirmationContainer = styled.div`
  width: 275px;
`;

const Icon = styled(HudIcon)`
  color: ${themeColor('gray')};
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 4px;

  &:hover {
    cursor: pointer;
    background-color: ${themeColor('buttonBackgroundHover')};
    border-radius: 4px;
  }
`;

export default {
  Container,
  Icon,
  Buttons,
  ConfirmationContainer,
  MenuItem,
};
